import React from 'react';
import { translate } from '@utils/i18n';
import { Accordion } from '@ui/molecules/Accordion';
import { Text } from '@ui/atoms/Text';
import { useSubcontractorPdfDocuments } from './hooks/useSubcontractorPdfDocuments';
const namespace = 'features.inspections_attachments';
export function SubcontractorDocumentsSection({ inspectionId }) {
    const { data: docs = [] } = useSubcontractorPdfDocuments(inspectionId);
    if (docs.length === 0)
        return null;
    return (React.createElement("div", { className: "mt-3" },
        React.createElement(Accordion, { variant: "section", defaultExpanded: true, title: React.createElement(Text, { variant: "small" }, translate('subcontractor_documents.header', { namespace, count: docs.length })) },
            React.createElement(Text, { variant: "xx-small", as: "p" }, translate('subcontractor_documents.manage_hint', { namespace })),
            React.createElement("div", { className: "qmb-card" },
                React.createElement("table", { className: "qmb-table attachment-table" },
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", null, translate('table.col_file', { namespace })))),
                    React.createElement("tbody", null, docs.map((doc) => (React.createElement("tr", { key: doc.id },
                        React.createElement("td", null,
                            React.createElement("div", { className: "qmb-file" },
                                React.createElement("span", { className: "qmb-file__icon" },
                                    React.createElement("i", { className: "fa-light fa-file-pdf", "aria-hidden": "true" })),
                                React.createElement("div", { className: "qmb-file__info" },
                                    React.createElement("div", { className: "qmb-file__name", title: doc.fileName }, doc.fileName),
                                    React.createElement("div", { className: "qmb-file__sub" },
                                        React.createElement("a", { href: doc.downloadUrl, target: "_blank", rel: "noreferrer", title: doc.fileName },
                                            React.createElement("i", { className: "fa-solid fa-download", "aria-hidden": "true" }),
                                            React.createElement("span", { className: "qmb-file__sub-text" }, doc.fileName)))))))))))))));
}
